import Vue from 'vue';
import Router from 'vue-router';
import { setupLayouts } from 'virtual:generated-layouts';
import generatedRoutes from 'virtual:generated-pages';
import compact from 'lodash-es/compact';

Vue.use(Router);

for (const [index, route] of generatedRoutes.entries()) {
  if (route.path === '/:all(.*)*') {
    generatedRoutes.push(route);
    generatedRoutes.splice(index, 1);
  }
}

const routes: any[] = setupLayouts(generatedRoutes);

export { routes };

const router = new Router({
  mode: 'history',
  routes,
});

const originPush = Router.prototype.push;
const originReplace = Router.prototype.replace;
// @ts-ignore
Router.prototype.replace = function replace(location, resolve, reject) {
  originReplace.call(this, location, resolve || (() => {}), reject || (() => {}));
};
// @ts-ignore
Router.prototype.push = function push(location, resolve, reject) {
  originPush.call(this, location, resolve || (() => {}), reject || (() => {}));
};

/**
 * 去掉多余的斜杠，以匹配一些规则
 * @param {string} path
 * @return {*}
 */
export const fixPath = (path: string) => {
  return `/${compact(path.split('/')).join('/')}`;
};

export default router;
